import { makeApiRequest } from 'actions/api';
import { getPartnerDeals } from 'actions/partnerDeals';
import { getStreakOffers } from 'actions/streakOffers';
import { getUser } from 'actions/user';
import RequestService from 'services/RequestService';

export const GET_OFFER_REWARDS = 'GET_OFFER_REWARDS';
export const GET_OFFER_REWARDS_RESPONSE = 'GET_OFFER_REWARDS_RESPONSE';

export const GET_VOUCHER_DETAILS = 'GET_VOUCHER_DETAILS';
export const GET_VOUCHER_DETAILS_RESPONSE = 'GET_VOUCHER_DETAILS_RESPONSE';

export const GET_CREDIT_DETAILS = 'GET_CREDIT_DETAILS';
export const GET_CREDIT_DETAILS_RESPONSE = 'GET_CREDIT_DETAILS_RESPONSE';

export const getOfferRewards = () =>
  makeApiRequest({
    requestType: GET_OFFER_REWARDS,
    method: RequestService.getOfferRewards,
  });

export const getVoucherDetails = () =>
  makeApiRequest({
    requestType: GET_VOUCHER_DETAILS,
    method: RequestService.getVoucherDetails,
  });

export const getCreditDetails = () =>
  makeApiRequest({
    requestType: GET_CREDIT_DETAILS,
    method: RequestService.getCreditDetails,
  });

export const bootstrapOfferRewards = () => dispatch => {
  dispatch(getUser());
  dispatch(getCreditDetails());
  dispatch(getOfferRewards());
  dispatch(getPartnerDeals());
  dispatch(getStreakOffers());
  dispatch(getVoucherDetails());
};
